/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const mobileMenu = () => {
    $(".mobile-menu-sp").on("click", function(){
      $("html").toggleClass("hide");
      $(this).toggleClass("active");
      $(".header-bottom").toggleClass("active");
    });
  };

  const fullSearch = () => {
    $(".header-search, .mobile-search").on("click", function(){
      $(".full-search").toggleClass("active");
      $("html").toggleClass("hide");
    });
    $(".full-search .full-search-bg").on("click", function(){
      $(".full-search").removeClass("active");
      $("html").removeClass("hide");
    });
  };

  const mobileDetailPageMenu = () => {
    if (window.matchMedia('(max-width: 992px)').matches) {
      $(".pg-left-menu-title").on("click", function(){
        $(".pg-left-menu-item").slideToggle();
      });
    }
  };

  const init = () => {
    mobileMenu();
    fullSearch();
    mobileDetailPageMenu();
  };

  return {
    init,
  };
})();

export default header;
